export const PageHeader = ({ title, subtitle, eyebrow, children }) => (
  <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between mb-6">
    <div>
      {eyebrow && <p className="text-xs uppercase tracking-[0.18em] text-gold font-medium mb-1">{eyebrow}</p>}
      <h1 className="font-display text-2xl md:text-3xl tracking-tight text-foreground">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
  </div>
);
